import { FunctionComponent } from 'react';

import styles from './Container.module.scss';

export type ContainerProps = {
  maxWidth?: 'sm' | 'md' | 'lg';
  height?: 'full';
  padTop?: 'sm' | 'md' | 'lg';
  padBottom?: 'sm' | 'md' | 'lg';
  children?: React.ReactNode;
  className?: string;
};

type FC = FunctionComponent<ContainerProps>;

const Container: FC = ({ maxWidth = 'lg', height, padTop, padBottom, children, className }: ContainerProps) => (
  <div
    className={[
      styles.container,
      styles[`maxWidth-${maxWidth}`],
      styles[`height-${height}`],
      styles[`padTop-${padTop || ''}`],
      styles[`padBottom-${padBottom || ''}`],
      className || '',
    ].join(' ')}
  >
    {children}
  </div>
);

export default Container;
